import { onMounted, ref } from "vue";
import { templateRef } from "@vueuse/core";
import { useScrollTriggerAnimation } from "/composables/useScrollTriggerAnimation";


export default {
  __name: 'index',
  props: {
  dataProvider: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const { reveal } = useScrollTriggerAnimation();
const tpl_grid = templateRef("tpl_grid");
const tpl_buttonsWrapper = ref(null);
const tpl_buttons = ref(null);

function getIcon(uuid) {
  let icon;

  switch (uuid) {
    case "509":
      icon = "application-bathtub";
      break;

    case "511":
      icon = "application-bidet";
      break;

    case "508":
      icon = "application-kitchen";
      break;

    case "510":
      icon = "application-shower";
      break;

    case "512":
      icon = "application-washbasin";
      break;
  }

  return icon;
}

onMounted(() => {
  tpl_buttonsWrapper.value = tpl_grid.value.$el.children[1];
  tpl_buttons.value = tpl_buttonsWrapper.value.children[0];

  reveal(tpl_buttons.value, tpl_buttonsWrapper.value, "scale-up", {
    intensity: "weak",
    fade: true,
    duration: "long",
  });
});

return { __sfc: true,props, reveal, tpl_grid, tpl_buttonsWrapper, tpl_buttons, getIcon }
}

}